/* @flow */
import { ENV } from 'config';

/**
 * Purpose of this class is to handle error in one place and integrate with third party systems
 * to log multiple type of errors.
 */
class ErrorHandlerService {
  url = 'http://localhost:3010/errors';

  constructor() {
    // console.log('constructed ErrorHandlerService');
  }

  static logError() {
    // integrate here with Rollbar, Azure Insights or any other system to log errors.
    //Send env name to separate errors
    // console.log('Environment: ' + ENV);
  }

  handleException(e: Error, source?: string) {
    if (typeof source === 'string') {
      e.source = source;
    }

    if (ENV === 'development') {
      this.logToConsole(e, source);
    }
  }

  logToConsole(e, source) {
    if (typeof e === 'object') {
      console.log(e.error);
      //
      console.log(e.info);
    }

    console.log(e);
  }

  /**
   * Convert exception that is displayed in console into a string that
   * can be reproduced after decoding.
   *
   * @param e
   * @returns {{error: string}}
   */
  convertErrorToString(e) {
    let stack = e.stack
      .split('\n')
      .reverse()
      .slice(0, -2)
      .reverse()
      .join('\n');
    // console.log(stack);
    // This is ready to be POSTed to error server for history
    let error = { error: stack };
    // console.log(JSON.stringify(error));
    return error;
  }

  logInfo(e) {
    console.log('logging info');
    // let response = fetch(this.url, {
    //   method: 'POST',
    //   headers: {
    //     'Content-Type': 'application/json;charset=utf-8',
    //   },
    //   body: JSON.stringify({ error: 'something happened' }),
    // })
    //   .then(response => response.json())
    //   .then(data => console.log(data));

    // console.log(response);
  }

  logError() {}

  debug() {}
}

export default ErrorHandlerService;
